var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutofillOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27396 5.99999C5.17486 6.00056 5.07662 5.98165 4.98488 5.94434C4.89314 5.90704 4.8097 5.85208 4.73934 5.7826L0.221446 1.28491C0.0796565 1.14375 0 0.952306 0 0.752682C0 0.553059 0.0796565 0.361611 0.221446 0.220456C0.363235 0.0793003 0.555543 0 0.756063 0C0.956584 0 1.14889 0.0793003 1.29068 0.220456L5.27396 4.19342L9.25724 0.227952C9.40128 0.105145 9.58657 0.0409732 9.77608 0.0482603C9.96559 0.0555475 10.1454 0.133757 10.2795 0.267259C10.4136 0.400762 10.4921 0.579724 10.4994 0.768384C10.5068 0.957044 10.4423 1.14151 10.3189 1.28491L5.80105 5.7826C5.66079 5.92109 5.4715 5.99916 5.27396 5.99999Z",
    fill: "#535252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutofillOpen);
export default __webpack_public_path__ + "static/media/AutofillOpen.a7a5ceea676c4d8b15dece2ed29a6b97.svg";
export { ForwardRef as ReactComponent };